export default "__VITE_ASSET__CSRCpZ$a__"